import { render, staticRenderFns } from "./PageDownloadPDFTest.vue?vue&type=template&id=6176148a&"
import script from "./PageDownloadPDFTest.vue?vue&type=script&lang=js&"
export * from "./PageDownloadPDFTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports